import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonial.css";
import { Button } from "reactstrap";

//import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";

{/* const PreviousBtn = (props) => {
  console.log(props);
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowBackIos style={{ color: "gray", fontSize: "45px" }} />
    </div>
  );
};
const NextBtn = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowForwardIos style={{ color: "gray", fontSize: "45px" }} />
    </div>
  );
};
*/}
const Testimonial = () => {
  const handleButtonClick = (clientName, url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert(`Website coming soon! Contact us for more information about ${clientName}.`);
    }
  };

  return (
    <div
      className="testimonial"
      style={{ 
        display: "flex", 
        justifyContent: "center", 
        marginTop: 50,
        padding: '40px 0'
      }}
    >
      <div style={{ 
        width: "90%", 
        textAlign: "center",
        maxWidth: '1200px'
      }}>
        <Slider 
          dots={true}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          autoplay={true}
          autoplaySpeed={5000}
          pauseOnHover={true}
          arrows={true}
          className="testimonial-slider"
        >
          <div>
            <Card
              img={require("assets/img/Aram.jpeg").default}
              p="We are located in Saudi Arabia (KSA ), though we didn't feel any distance matter while working with Tri-Advise, they delivered us an outstanding website with lots of features available in the market. Very professional, on time, communicates in a timely manner and has amazing ideas for the best marketing message. "
              p2="Aram Al-Jazeera"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ff6b6b, #feca57)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 107, 107, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Aram Al-Jazeera", "https://aramaljazeera.com/")}
            >
              Visit Aram Al-Jazeera
            </Button>
          </div>
          <div>
            <Card
              img={require("assets/img/faraj.jpeg").default}
              p="The entire team at Tri-Advise is top notch! They understand the creative side and deliver on time. They re-vamped our website, and the results were fabulous. I highly recommend Tri-Advise for any online marketing needs."
              p2="Faraj Automotive"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Faraj Automotive", "https://farajautomotive.com/")}
            >
              Visit Faraj Automotive
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/10.eb69b6ce.png"
              p="The reason we chose Tri-Advise over other companies was their value 
          for great customer service and their focus on having interactive and engaging 
          websites and social media."  />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #48cae4, #023e8a)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(72, 202, 228, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Saifan", "https://saifanlb.com/")}
            >
              Visit Saifan
            </Button>

          </div>
          <div>
            <Card img="https://tri-advise.com/static/media/f3.0c6a1de8.jpg"
              p="These guys are incredibly talented and reliable. They always go above and beyond for us. Highly recommend.  "
              p2="Glamour Girlstores " />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ff9a9e, #fecfef)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 154, 158, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Glamour Girlstores")}
            >
              Visit Glamour Girlstores
            </Button>
          </div>
          <div>
            <Card img="https://tri-advise.com/static/media/f4.441328bf.jpg"
              p="Working with Tri-Advise has been fantastic. It isn't easy choosing the right company to work with for marketing videos and website development, but they are very dedicated to getting the work done right. You can be confident that you will be happy choosing them.   "
              p2="BagshutbyDayan   " />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #a8edea, #fed6e3)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(168, 237, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("BagshutbyDayan")}
            >
              Visit BagshutbyDayan
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/9.11e24ffd.png" p="Greatest appreciation to you and your team for the outstanding job you did for us. We feel privileged to have Tri-Advise as our online marketing partner!" p2="Evora" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ffecd2, #fcb69f)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 236, 210, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Evora")}
            >
              Visit Evora
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/3.c5d39863.png" p="I am very satisfied! Enjoyable to work with, and most importantly, enabled us to have a strong online presence." p2="Fitness Garage" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Fitness Garage")}
            >
              Visit Fitness Garage
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/8.aa3fe562.png" p="Tri-Advise team Communications is attentive, personable, and professional. The team provides great support for my company's needs." p2="Tafasil" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #f093fb, #f5576c)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(240, 147, 251, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Tafasil")}
            >
              Visit Tafasil
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/11.f2f700ad.png" p="The team guidance and advice was invaluable in managing Social media accounts... we were thrilled with the way Tri-advise interacts. Without any hesitation... highly recommended." p2="Health Talks" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #4facfe, #00f2fe)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(79, 172, 254, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Health Talks")}
            >
              Visit Health Talks
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/5.ccb6eb06.png" p="Always available to answer any questions. Very knowledgeable about the services they provide. Would recommend it to anyone!" p2="DAB BBQ" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #fa709a, #fee140)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(250, 112, 154, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("DAB BBQ")}
            >
              Visit DAB BBQ
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/7.67dcb761.png" p="With QR code, it is easy as pie for our clients to scroll our Menu, and who is better than Tri-Advise to do it ?" p2="Delora" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #a8c0ff, #3f2b96)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(168, 192, 255, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Delora")}
            >
              Visit Delora
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/4.326ae2a7.png" p="It's always a pleasure to work with Tri-Advise and his team. They are personable, responsive, and results-oriented!" p2="A- LWS" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ff9a9e, #fad0c4)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 154, 158, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("A-LWS")}
            >
              Visit A-LWS
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/2.026ff070.png" p="On the social media front, there is no way we would have been able to gain the successes we have had on Facebook, Twitter, and LinkedIn without Tri-Advise." p2="Abe Barber" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ffecd2, #fcb69f)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 236, 210, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Abe Barber")}
            >
              Visit Abe Barber
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/1.434caa58.png" p="Tri-Advise is a remarkable Digital Marketing Agency." p2="Ice Bit" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Ice Bit")}
            >
              Visit Ice Bit
            </Button>
          </div>

          <div>
            <Card img="https://tri-advise.com/static/media/6.0749c0e4.png" p="It is a pleasure working with Tri-Advise. The team is extremely knowledgeable, business savvy, and positive. Their approach to challenges and opportunities is innovative. They are highly productive and consistently deliver as promised. And to top it all off, they are gracious, kind, and insightful." p2="GSM Trading" />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #4facfe, #00f2fe)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(79, 172, 254, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("GSM Trading")}
            >
              Visit GSM Trading
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/Tapley's Pizza.jpeg").default}
              p="Tapleys Pizza & Parmi has been blown away by Tri-Advise's digital marketing expertise! They created mouth-watering content that perfectly showcases our delicious offerings. Our social media engagement has increased by 400% and our delivery orders have doubled. They truly understand the food industry and how to make brands irresistible!"
              p2="Tapleys Pizza & Parmi"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ff9a9e, #fecfef)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 154, 158, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Tapleys Pizza & Parmi")}
            >
              Visit Tapleys Pizza & Parmi
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/Orca.jpeg").default}
              p="Orca Swimming Academy is absolutely thrilled with Tri-Advise's outstanding work! They created a comprehensive digital strategy that perfectly captures our passion for swimming excellence. Our enrollment has increased significantly, and parents love our new online presence. Their understanding of sports marketing and community building is truly exceptional!"
              p2="Orca Swimming Academy"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #a8edea, #fed6e3)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(168, 237, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Orca Swimming Academy")}
            >
              Visit Orca Swimming Academy
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/Al Safeer Steel.jpeg").default}
              p="Al Safeer Steel has experienced remarkable growth since partnering with Tri-Advise! They transformed our industrial brand into a modern, professional digital presence that resonates with our B2B clients. Their expertise in industrial marketing and their ability to make technical content engaging is truly impressive. Reaching 700K in just 40 days was beyond our expectations! We've seen a significant increase in qualified leads!"
              p2="Al Safeer Steel"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #a8c0ff, #3f2b96)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(168, 192, 255, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Al Safeer Steel", "https://www.instagram.com/alsafeer.steel?igsh=MW41cnd5MWJqcHk2cw==")}
            >
              Visit Al Safeer Steel
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/Tapley's Pizza.jpeg").default}
              p="Tri-Advise didn't just boost our online presence—they also designed our logo and menu, perfectly capturing our brand identity. Their marketing strategies brought in more customers than ever. Highly recommended!"
              p2="Tapleys Pizza (Australia)"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ff6b6b, #feca57)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 107, 107, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Tapleys Pizza", "https://www.facebook.com/share/15JsQYiyL4/?mibextid=wwXIfr")}
            >
              Visit Tapleys Pizza
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/salame store.jpeg").default}
              p="Tri-Advise helped us build a strong brand from the ground up, creating our logo and brand guidelines while driving outstanding visibility and engagement. Their expertise made a real difference!"
              p2="Salame Store (Lebanon)"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Salame Store", "https://www.facebook.com/share/1DMsSZqKHn/?mibextid=wwXIfr")}
            >
              Visit Salame Store
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/SKALA-Logo-Reversed-YELLOW (4).pdf").default}
              p="Tri-Advise delivered exceptional marketing results for Skala. Their strategic approach helped us reach a wider audience and strengthen our brand in the Gulf region."
              p2="Skala Solutions (Qatar & KSA)"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #48cae4, #023e8a)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(72, 202, 228, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Skala Solutions")}
            >
              Visit Skala
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/Lomenox.jpeg").default}
              p="From logo creation to branding and social media success, Tri-Advise delivered excellence at every step. Our brand now stands out, thanks to their expertise!"
              p2="LOMENOX (Lebanon)"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ffecd2, #fcb69f)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 236, 210, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("LOMENOX", "https://www.instagram.com/hinox_home?igsh=MWdzZHBmYWNsNzU2OQ==")}
            >
              Visit LOMENOX
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/Choubassi Jewelry.jpeg").default}
              p="Tri-Advise went above and beyond by optimizing our account settings and delivering our NFC business card, ensuring a seamless digital experience. Highly professional service!"
              p2="Choubassy Jewelry (Chtaura)"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #f093fb, #f5576c)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(240, 147, 251, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Choubassy Jewelry")}
            >
              Visit Choubassy Jewelry
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faraj.jpeg").default}
              p="For the third consecutive year, we've trusted Tri-Advise to elevate our brand. Their logo facelift, social media strategies, and company paper designs have reinforced our professional image. A truly valuable partnership!"
              p2="Faraj Automotive"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #4facfe, #00f2fe)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(79, 172, 254, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Faraj Automotive")}
            >
              Visit Faraj Automotive
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/BO7 Home Gadgets.jpeg").default}
              p="Tri-Advise played a key role in enhancing our digital presence, driving engagement, and optimizing our brand strategy. Their expertise helped BO7 Home Gadgets reach new heights!"
              p2="BO7 Home Gadgets"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #fa709a, #fee140)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(250, 112, 154, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("BO7 Home Gadgets", "https://www.instagram.com/bo7_homegadgets?igsh=Mzg1NzM2bDhxcWd1")}
            >
              Visit BO7 Home Gadgets
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/tamara sport.jpeg").default}
              p="We sincerely thank Tri-Advise for expertly managing all our marketing and digital marketing efforts. Your creativity and commitment have been key to Tamara Sport's growth and success. We value this partnership and look forward to more achievements together."
              p2="Tamara Sport"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Tamara Sport")}
            >
              Visit Tamara Sport
            </Button>
          </div>

          <div>
            <Card
              img={require("assets/img/faces/tamara couture.jpeg").default}
              p="At Tamara Couture, every detail matters — and so does every partnership. We thank Tri-Advise for crafting and managing our marketing and digital presence with the same level of care, creativity, and precision that defines our brand. Your work has elevated our story, our style, and our reach. We are proud to have you as part of our journey."
              p2="Tamara Couture"
            />
            <Button
              className="btn-round"
              style={{
                background: "linear-gradient(45deg, #ff6b6b, #feca57)",
                border: "none",
                padding: "12px 30px",
                borderRadius: "25px",
                color: "white",
                fontWeight: "600",
                boxShadow: "0 4px 15px rgba(255, 107, 107, 0.3)",
                transition: "all 0.3s ease",
                marginTop: "20px",
                cursor: "pointer"
              }}
              onClick={() => handleButtonClick("Tamara Couture")}
            >
              Visit Tamara Couture
            </Button>
          </div>
        </Slider>

      </div>
    </div>
  );
};



const Card = ({ img, p, p2 }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        color: "white",
        padding: "40px 20px",
        background: "rgba(255,255,255,0.1)",
        borderRadius: "20px",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.2)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        margin: "0 20px",
        transition: "all 0.3s ease",
        position: "relative",
        overflow: "hidden"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-10px)";
        e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.2)";
        e.currentTarget.style.background = "rgba(255,255,255,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.1)";
        e.currentTarget.style.background = "rgba(255,255,255,0.1)";
      }}
    >
      {/* Decorative quote mark */}
      <div style={{
        position: "absolute",
        top: "20px",
        left: "20px",
        fontSize: "60px",
        color: "rgba(255,255,255,0.1)",
        fontFamily: "serif",
        lineHeight: 1
      }}>
        "
      </div>
      
      <div
        style={{
          width: 120,
          height: 120,
          border: "3px solid rgba(255,255,255,0.3)",
          padding: 5,
          marginBottom: 30,
          marginLeft: "auto",
          marginRight: "auto",
          boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          borderRadius: "50%",
          overflow: "hidden"
        }}
      >
        {img && typeof img === 'string' && img.includes('.pdf') ? (
          <iframe
            src={img}
            type="application/pdf"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "50%"
            }}
            title={p2}
          />
        ) : (
          <img
            src={img}
            alt={p2}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "50%"
            }}
          />
        )}
      </div>
      
      <p style={{
        fontSize: "1.1rem",
        lineHeight: "1.8",
        marginBottom: "25px",
        marginLeft: "auto",
        marginRight: "auto",
        fontStyle: "italic",
        maxWidth: "600px",
        width: "100%",
        textAlign: "center",
        position: "relative",
        zIndex: 2
      }}>
        {p}
      </p>
      
      <div style={{ 
        fontStyle: "italic", 
        marginTop: 25,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        textAlign: "center",
        position: "relative",
        zIndex: 2
      }}>
        <span style={{ 
          fontWeight: 600, 
          color: "#feca57",
          fontSize: "1.2rem",
          textShadow: "0 2px 4px rgba(0,0,0,0.3)"
        }}>
          — {p2}
        </span>
      </div>
    </div>
  );
};

export default Testimonial;